











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DefaultTableButton extends Vue {
  @Prop({ default: "" })
  private buttonClass!: string;

  @Prop({ default: "cog" })
  private icon!: string;

  @Prop({ default: false })
  private clickable!: boolean;

  private clicked() {
    if (this.clickable) {
      this.$emit("click");
    }
  }
}
